import { Component, OnInit, Input} from '@angular/core';
import { GlobalService } from '@services/global.service';
import { Product, Categ, SCateg, Gamme, Marque, Tag, Banner } from '@models/product';

@Component({
  selector: 'gob-product-class',
  templateUrl: './product-class.component.html',
  styleUrls: ['./product-class.component.css']
})
export class ProductClassComponent implements OnInit {
  @Input() product: Product;
  loading: boolean=false;
  categs: Categ[]=[];
  scategs: SCateg[]=[];
  gammes: Gamme[]=[];
  marques: Marque[]=[];
  banners: Banner[]=[];
  tags: Tag[]=[];

  constructor(private gServ: GlobalService) {
    this.loading=true;
    this.gServ.getClassification()
      .subscribe(classes => {
        this.categs=classes.categs;
        this.scategs=classes.scategs;
        this.gammes=classes.gammes;
        this.marques=classes.marques;
        this.tags=classes.tags;
        this.banners=classes.banners;
        this.loading=false;
      });
  }

  ngOnInit(): void {
  }

  rm(i: number){
    this.product.banners.splice(i, 1);
  }

  add(){
    let banner: Banner=new Banner();
    if(this.availableBanners.length)
      banner.ident=this.availableBanners[0].ident;
    this.product.banners.push(banner);
  }

  /**
   * Retourne la liste des bannières disponibles dans le select.
   * Si une bannière "Précommande" est déjà sur le produit,
   * on retire "Nouveautés" de la liste car elle est gérée automatiquement.
   */
  get availableBanners(): Banner[] {
    const hasPreco = this.product?.banners?.some(b => this.isPrecoBanner(b.ident));
    if (!hasPreco) return this.banners;
    return this.banners.filter(b => !this.isNouveauteBanner(b.ident));
  }

  rmTag(i: number){
    this.product.tags.splice(i, 1);
  }

  getTag(ident: string){
    return this.tags.find(tag => tag.ident==ident);
  }

  getTagList(){
    let result: Tag[]=[];
    this.tags.forEach(tag => {
      if(!this.product.tags.find(t => tag.ident==t.ident))
        result.push(tag);
    });
    return result;
  }

  getBanner(ident: string){
    return this.banners.find(banner => banner.ident==ident);
  }

  /**
   * Retourne les bannières du produit à afficher dans le formulaire.
   * Si une bannière "Précommande" est présente, on masque les bannières
   * "Nouveautés" car elles sont ajoutées automatiquement par le serveur
   * et ne doivent pas apparaître en double dans l'interface.
   */
  get displayedBanners(): Banner[] {
    const hasPreco = this.product.banners.some(b => this.isPrecoBanner(b.ident));
    if (!hasPreco) return this.product.banners;

    return this.product.banners.filter(b => !this.isNouveauteBanner(b.ident));
  }

  /**
   * Checks if a banner is a preco banner
   * @param {string} ident - banner ident
   * @returns {boolean} true if the banner is a preco banner
   */
  isPrecoBanner(ident: string): boolean {
    const selected = this.banners.find(b => b.ident === ident);
    return selected?.name?.toLowerCase().includes('précommande') ?? false;
  }

  isNouveauteBanner(ident: string): boolean {
    const found = this.banners.find(b => b.ident === ident);
    return found?.name?.toLowerCase().includes('nouveauté') ?? false;
  }

  updateReleaseDate(banner: Banner) {
    if (this.isPrecoBanner(banner.ident) && banner.end) {
      const endDate = new Date(banner.end);
      endDate.setDate(endDate.getDate() + 1);
      const releaseDateStr = endDate.toISOString().split('T')[0];
      this.product.releaseDate = releaseDateStr;
    }
  }

  onBannerChange(banner: Banner) {
    if (this.isNouveauteBanner(banner.ident) && this.product.releaseDate) {
      banner.start = this.product.releaseDate;
    }
  }
}